<template>

      <v-container fluid   v-bind:style="stylePagina">
        <v-row   justify="center" align="center" class="full-height">

          <v-col  cols="12" sm="12" lg="6" md="6" style="margin-top: 10% !important;" >
            <p><v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/omen/Recurso+3.png"></v-img></p>
                              <v-card color="transparent" class="mt-sm-12">
                                  <v-card-text>
                                      <v-form ref="form1">
                                      <v-row class="pt-6 pr-2 pl-2">



                              <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-text-field v-model="editedItem.socioPrincipal.nombre" :label="negociodisenio.labelNombre" :rules="[rules.required]"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-text-field  v-model="editedItem.socioPrincipal.apellidoPaterno" :label="negociodisenio.labelAppaterno" :rules="[rules.required]"></v-text-field>
                              </v-col>

                                        <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                          <v-text-field prepend-icon="fas fa-at" v-model="editedItem.socioPrincipal.email"  :label="$t('formularios.Email')" :rules="[rules.required]"></v-text-field>
                                        </v-col>

                                        <v-col   cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                          <v-text-field v-if="negociodisenio.campodireccion"  v-model="editedItem.socioPrincipal.direccion" :label="$t('formularios.Direccion')" :rules="[rules.required]"></v-text-field>
                                        </v-col>
                                          <v-col   cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                              <div style="position: relative;"><div style="position: absolute; left:0; right:auto; transform-origin: top left;">Fecha Nacimiento</div>
                                                  <v-row>
                                                      <v-col cols="3"><v-select
                                                              v-model="dia"
                                                              :items="dias"
                                                              @change="changedia"
                                                      >

                                                      </v-select></v-col>
                                                      <v-col cols="4">
                                                          <v-autocomplete
                                                                  v-model="mes"
                                                                  :items="meses"
                                                                  item-text="mes"
                                                                  item-value="fec"
                                                                  @change="changemes"
                                                          >

                                                          </v-autocomplete></v-col>
                                                      <v-col cols="5">
                                                          <v-autocomplete
                                                                  :items="anios"
                                                                  v-model="anio"
                                                                  @change="changeanio"
                                                          >

                                                          </v-autocomplete></v-col>
                                                  </v-row></div>
                                          </v-col>










                                          <v-col  cols="12" sm="12" md="12">
                                              <v-btn v-bind:style="btnPag" v-model="boton"  @click="save">Enviar</v-btn>
                                          </v-col>

                                      </v-row></v-form>
                                  </v-card-text>
                              </v-card>

          </v-col>
        </v-row>


      </v-container>


</template>

<script>
import axios from 'axios';
import moment from "moment-timezone";


export default {
  name: "membresia",
  components: {
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Inscripción de socios a "+this.titulonegocio
      }
    ]
    }
  },
  data () {
    return{
      idnegocio: 0,
      overlay:false,
      alertnuevo:false,
      alertnoacepto:false,
      alerterror:false,
      activePicker:null,
      logoexist: false,
      logoimg: null,

        step:1,
      respuesta:'',
      rese:'',
        rules: {
            required: value => !!value || 'Requerido.',
            counter: value => value.length <= 20 || 'Max 20 characters',
            fotomin: value => !value || value.size < 1000000 || 'Tamaño de foto no debe ser mayor a 1 MB!',
            minimo: value => value.length >= 3 || 'Minimo 3 caracteres',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Mail invalido.'
            },
        },
      browser:false,
      normal:true,
      login:false,
      registro:false,
      boton:false,
        ancho:270,
      menu: false,
      fechamax:null,
      dias:[],
      anios:[],
      aniomax:0,
      aniomin:1950,
      meses:[{
        fec:'01',
        mes:'Enero'
      },{
        fec:'02',
        mes:'Febrero'
      },{
        fec:'03',
        mes:'Marzo'
      },{
        fec:'04',
        mes:'Abril'
      },{
        fec:'05',
        mes:'Mayo'
      },{
        fec:'06',
        mes:'Junio'
      },{
        fec:'07',
        mes:'Julio'
      },{
        fec:'08',
        mes:'Agosto'
      },{
        fec:'09',
        mes:'Septiembre'
      },{
        fec:'10',
        mes:'Octubre'
      },{
        fec:'11',
        mes:'Noviembre'
      },{
        fec:'12',
        mes:'Diciembre'
      }],
      diamax:31,
      diamin:1,
      form: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        dni : "",
        foto: "",
        email: "",
        paisNac:{},
        tipoDocumento: {},
        telefono:"",
        direccion:"",
        fechaNacimiento:new Date().toISOString().substr(0, 10),
        sexo:{},
        fotoDni:"",
        postalCode:"",
        distrito:{},
        createdAt:"",
        uidFirebase: "",
        grupoUsuario:{},
        isprofile: true,
        isfoto : false,
        isverified: false
      },
      email: '',
      password:'',
      errorcon: 'Tienes que Aceptar las Condiciones',
      error:'',
      password2:'',
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
     hayimagen: false,
      imagen:'',
      dia:'01',
      mes:'01',
      anio:'1990',
      token:'',
      imagen2:'',
      paises:[],
      provincias:[],
      ciudades:[],
      distritos: [],
      sexos: [{id:0,sexo:"Escoger Sexo"}, {id:1, sexo:"Masculino"}, {id:2, sexo:"Femenino"}],
      tiposdoc: [],
      negocio:[],
      tiposcarnets:[],
      Contactos:[],
      negociodisenio: {
        campoapmaterno: false,
        campodireccion: false,
        campodistrito: false,
        campofecnac: false,
        campofoto: false,
        campoinvitado: false,
        campoizqder: false,
        camporeferido: false,
        camposexo: false,
        campotelefono: false,
        campofumador: false,
        campotipocarnet: false,
        campocontacto: false,
        campocondiciones:false,
        condiciones: '',
          labelApmaterno:'Apellido Materno',
          labelAppaterno:'Apellido Paterno',
          labelNombre:'Nombres'
      },
      editedItem: {
        id:0,
        fecha: new Date(),
        estadoCarnet: {
          id:0,
          estadoCarnet:'',
          color: ''
        },
        formaEnvio: {
          id:0,
          formaEnvio:''
        },
        tipoPago : {
          id:0,
          tipoPago:'',
          visiblePagina:true
        },
        tipoMembresia: {
          id:0,
          tipoMembresia:''
        },
        tipoCarnetSocio:{
          id:0,
          tipoCarnet:'',
          frontal:0,
          temporada:{
            id:0,
            negocio:{
              id:0,
              negocio:'',
              cliente:{
              },
              activo:true,
              icono:'',
              logo:'',
              impuesto:'',
              moneda:{
              },
              tag:'',
              latitud:0,
              longitud:0,
              horaApertura: null,
              horaCierre: null,
              tipoNegocio:{},
              direccion:''
            },
            temporada:'',
            activa:true,
            listas:true,
            inscripcion:true,
            createdAt:null
          },
          activo: true,
          backFront:'',
          backBack:'',
          textColor:'',
          descripcion:'',
          basico:true,
          createdAt:null
        },
        temporada:{},
        contacto:{
          id:0,
          contacto:'SIN CONTACTO'
        },
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        socioPrincipal: {
          id:0,
          nombre:'',
          apellidoMaterno:'',
          apellidoPaterno:'',
          dni:'',
          foto:'',
          email:'',
            instagram:'',
          fechaNacimiento: null,
          telefono:'',
          direccion:'',
          sexo:{
            id:0,
            sexo:''
          },
          tipoDocumento:{
            id:0,
            tipoDocumento:''
          },
          paisNac:{
            id:0,
          },
          fotoDni:'',
          postalCode:'',
          distrito:{id:0,
          distrito:'',
          ciudad:{
           id:0,
           ciudad:'',
            provincia:{id:0,
            provincia:'',
            pais:{
              id:0,
              pais:''
            }}
          }},
          createdAt:null,
          uidFirebase:'',
          isprofile:true,
          isfoto: false,
          isverified: false,
          socio:false,
        },
        fechaInicio: null,
        fechaFin: null,
      },
      defaultItem: {
        id:0,
        fecha: new Date(),
        estadoCarnet: {
          id:0,
          estadoCarnet:'',
          color: ''
        },
        formaEnvio: {
          id:0,
          formaEnvio:''
        },
        tipoPago : {
          id:0,
          tipoPago:'',
          visiblePagina:true
        },
        tipoMembresia: {
          id:0,
          tipoMembresia:''
        },
        tipoCarnetSocio:{
          id:0,
          tipoCarnet:'',
          frontal:0,
          temporada:{
            id:0,
            negocio:{
              id:0,
              negocio:'',
              cliente:{
              },
              activo:true,
              icono:'',
              logo:'',
              impuesto:'',
              moneda:{
              },
              tag:'',
              latitud:0,
              longitud:0,
              horaApertura: null,
              horaCierre: null,
              tipoNegocio:{},
              direccion:''
            },
            temporada:'',
            activa:true,
            listas:true,
            inscripcion:true,
            createdAt:null
          },
          activo: true,
          backFront:'',
          backBack:'',
          textColor:'',
          descripcion:'',
          basico:true,
          createdAt:null
        },
        temporada:{},
        contacto:{
          id:0,
          contacto:''
        },
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        socioPrincipal: {
          id:0,
          nombre:'',
          apellidoMaterno:'',
          apellidoPaterno:'',
          dni:'',
          foto:'',
          email:'',
          fechaNacimiento: null,
          telefono:'',
          direccion:'',
          sexo:{
            id:0,
            sexo:''
          },
          tipoDocumento:{
            id:0,
            tipoDocumento:''
          },
          paisNac:{
            id:0,
          },
          fotoDni:'',
          postalCode:'',
          distrito:{id:0,
            distrito:'',
            ciudad:{
              id:0,
              ciudad:'',
              provincia:{id:0,
                provincia:'',
                pais:{
                  id:0,
                  pais:''
                }}
            }},
          createdAt:null,
          uidFirebase:'',
          isprofile:false,
          isfoto: false,
          isverified: false,
          socio:false,
        },
        fechaInicio: null,
        fechaFin: null,
      },
      stylePagina: {
        backgroundColor: '#E6E6E6',
        backgroundImage : 'url("https://tunaydisenio.s3.sa-east-1.amazonaws.com/omen/fondo+1.png")',
        color:'white',
        backgroundSize: 'cover',
      },

      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      }

    }
  }
  ,
  created() {
    this.$vuetify.theme.dark = false

  },
  mounted (){
    this.idnegocio =  this.$route.params.idnegocio;

    this.damenegocio();
    this.fnBrowserDetect();
    this.fechamax =this.formatDatee(new Date(new Date().setFullYear(new Date().getFullYear() - 18)))
    this.date = this.fechamax
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date);
    for (let i = 1; i<=this.diamax;i++){
      this.dias.push(i.toString().padStart(2,"0"))
    }
    let anchoventana = window.innerWidth

      if(anchoventana>1904){
          this.ancho = 270
      }else{
          if(anchoventana>1264){
              this.ancho=270
          }else{
              if(anchoventana>960){
                  this.ancho=270
              }else{
                  if(anchoventana>600){
                      this.ancho =180
                  }else{
                      this.ancho = 90
                  }
              }
          }
      }

    this.aniomax = moment(this.date).year()
    for (let i = this.aniomin; i<=this.aniomax;i++){
      this.anios.push(i)
    }
    this.anio= this.aniomax
  }
,
watch: {
  date () {
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date)
  },
  menu (val) {
    val && setTimeout(() => (this.activePicker = 'YEAR'))
  },
},

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    changemes(){
      if ( this.mes ==="02"){
        this.diamax=29
        this.dias = []
        for (let i = 1; i<=this.diamax;i++){
          this.dias.push(i.toString().padStart(2,"0"))
        }
      }else{
        if(this.mes === "01" || this.mes === "03" || this.mes === "05" || this.mes === "07" || this.mes === "08" || this.mes === "10"  || this.mes === "12" )
        { this.diamax =31
          this.dias = []
          for (let i = 1; i<=this.diamax;i++){
            this.dias.push(i.toString().padStart(2,"0"))
          }
        }else{
          this.diamax = 30
          this.dias = []
          for (let i = 1; i<=this.diamax;i++){
            this.dias.push(i.toString().padStart(2,"0"))
          }
        }
      }
      this.editedItem.socioPrincipal.fechaNacimiento = this.dia.toString().padStart(2, '0')  + '-' + this.mes + '-' + this.anio.toString()
    },
    changeanio(){
      this.editedItem.socioPrincipal.fechaNacimiento =  this.dia.toString().padStart(2, '0')  + '-' + this.mes + '-' + this.anio.toString()

    },
    changedia(){
      this.editedItem.socioPrincipal.fechaNacimiento =  this.dia.toString().padStart(2, '0')  + '-' + this.mes + '-' + this.anio.toString()
    },
    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },

    formatFecha(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    save () {

      if(this.negociodisenio.campofoto){
      if(this.editedItem.socioPrincipal.foto.length>2 ){
       this.revisareferido();
      }else{
        this.alertnoacepto = true
        this.errorcon = "Debe subir una foto"
      }
      }else{
        this.revisareferido();
      }

    },
    revisareferido(){
      if(this.negociodisenio.camporeferido){
        if(this.editedItem.referido.length>2 ){
          this.editedItem.contacto = {
            id:0,
            activo:true,
            contacto: this.editedItem.referido,
            negocio: {}
          }
          this.basicos();
        }else{
          this.alertnoacepto = true
          this.errorcon = "Debe Agregar un Referido"
        }
      }else{
          this.revisacontacto();
      }
    },
    revisacontacto(){
      if(this.negociodisenio.campocontacto){
        if(this.editedItem.contacto.id>0 ){
          this.basicos();
        }else{
          this.alertnoacepto = true
          this.errorcon = "Debe Escoger un Contacto"
        }
      }else{
        this.basicos();
      }
    },
    basicos(){
      if(this.editedItem.socioPrincipal.apellidoPaterno.length>2){
        if(this.editedItem.socioPrincipal.nombre.length>2){
          if(this.editedItem.socioPrincipal.dni.length>7){

              if(this.editedItem.aceptoCondicion)
              {
                this.grabar();
              }else{
                this.alertnoacepto =true
                this.errorcon = "Tienes que Aceptar las Condiciones"
              }
          }else{
            this.alertnoacepto =true
            this.errorcon = "Debe Ingresar un documento correcto "
          }}else{
          this.alertnoacepto =true
          this.errorcon = "Debe Ingresar un nombre correcto"
        }}else{
        this.alertnoacepto =true
        this.errorcon = "Debe Ingresar un apellido correcto"
      }
    },
    grabar(){
      this.overlay = true;



      var bodyFormData2 = new FormData();

      if (this.editedItem.socioPrincipal.fechaNacimiento === "Fecha inválida"){
        this.editedItem.socioPrincipal.fechaNacimiento = null;
      }else{
          this.editedItem.socioPrincipal.fechaNacimiento = this.dia+'-'+this.mes+'-'+this.anio
      }

      this.editedItem.socioPrincipal.email = this.editedItem.socioPrincipal.email.toLowerCase().trim();
      bodyFormData2.append("persona",JSON.stringify(this.editedItem.socioPrincipal));
      bodyFormData2.append("tipoCarnetId",this.editedItem.tipoCarnetSocio.id);
      bodyFormData2.append("contacto",JSON.stringify(this.editedItem.contacto));
      bodyFormData2.append("referido",this.editedItem.referido);
      bodyFormData2.append("condicion",this.negociodisenio.condiciones);


      axios
          .post('membresia/crear',bodyFormData2).then(response => {
        let usuariodto = response.data
        this.respuesta = usuariodto.respuesta
        this.editedItem = this.defaultItem
        this.alertnuevo = true;
        this.overlay = false;
        this.step = 1;
        this.fechamax =this.formatDatee(new Date(new Date().setFullYear(new Date().getFullYear() - 18)))
        this.date = this.fechamax
        this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date);
        for (let i = 1; i<=this.diamax;i++){
          this.dias.push(i)
        }

        this.aniomax = moment(this.date).year()
        for (let i = this.aniomin; i<=this.aniomax;i++){
          this.anios.push(i)
        }
        this.anio= this.aniomax
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.alerterror = true
            console.log(error);
            this.overlay = false;
          });

    },

      damexemail(){

          var bodyFormData2 = new FormData();
          bodyFormData2.append("email",this.editedItem.socioPrincipal.email);
          axios
              .post('personas/email',bodyFormData2).then(response => {
                  if(response.data.email === this.editedItem.socioPrincipal.email){
                      this.editedItem.socioPrincipal = response.data
                      let fechanc =  new Date(response.data.fechaNacimiento+'T12:00:00')
                      this.dia = fechanc.getDate().toString().padStart(2,"0")
                      let elmes =   fechanc.getMonth() + 1
                      this.mes = elmes.toString().padStart(2,"0")
                      this.anio = fechanc.getFullYear()
                  }

          })
              .catch(error => {
                  this.error = "Hubo un error";
                  this.alerterror = true
                  console.log(error);
                  this.overlay = false;
              });
      },

    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },

    formatfechanac(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    cambiaCheck(){
      if(this.editedItem.aceptoCondicion){
       this.boton = true
      }else{
        this.boton = false
      }
    },
    damedisenio(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('hasp', this.idnegocio);
      axios
          .get('negociodisenio/membresia/'+ this.idnegocio)
          .then(response => {
            this.negociodisenio = response.data;

            if (this.negociodisenio.negocio.logo270 === null){
                this.logoexist = false;
            }else{
              this.logoexist  = true;
              this.logoimg = this.negociodisenio.negocio.logo270;
            }
            if (this.negociodisenio.condiciones !== '' && this.negociodisenio.condiciones !== null){
              this.campocondiciones = true
              this.condiciones = this.negociodisenio.condiciones
              this.editedItem.condicionAceptada = this.condiciones
            }

            this.titulonegocio = this.negociodisenio.negocio.negocio;
            let objPag= {
              backgroundColor: this.negociodisenio.backgroundColor,
              color:this.negociodisenio.colorText,
              backgroundImage:'url(' + this.negociodisenio.backgroundImage + ')',
                backgroundSize:'cover'
            }
            let btnPag= {
              backgroundColor: this.negociodisenio.colorBgBoton,
              color:this.negociodisenio.colorTxtBoton
            }
            this.btnPag = btnPag
            this.stylePagina = objPag
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>
<style>
.grecaptcha-badge{
  display: none;
}
.theme--light.v-card{
  background-color: transparent !important;
}
.full-height {
  height: 100vh;      /* Establece la altura al 100% de la ventana */
  display: flex;      /* Usa el modelo de caja flexible */
  flex-direction: column; /* Columnas flexibles */
}
</style>